module.exports = __webpack_public_path__ + "img/U1F340.23238fe7.png";